import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./FullImage.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
export interface FullImage {
  alt: string;
  image: SanityImageObject;
}
export const FullImage: React.FC<FullImage> = t0 => {
  const $ = _c(3);
  const {
    alt,
    image
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== image) {
    t1 = <div className={styles.wrapper}><ResponsiveImage image={image} alt={alt} layout="responsive" sizes="100vw" /></div>;
    $[0] = alt;
    $[1] = image;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};